
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcVerticalLine as ObcVerticalLineElement} from '@oicl/openbridge-webcomponents/dist/automation/vertical-line/vertical-line.js';
 
 
 

 
 export const ObcVerticalLine = createComponent({
   react: React,
   tagName: 'obc-vertical-line',
   elementClass: ObcVerticalLineElement,
   events: {
     
   }
  });
 
 